/**
 * @prettier
 */
import { ArchivedClients } from "./ArchivedClients";

export default ArchivedClients;
